import { supabase } from './supabase';

export async function isAdmin(): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('is_admin');
    if (error) throw error;
    return !!data;
  } catch (err) {
    console.error('Error checking admin status:', err);
    return false;
  }
}

export async function isSelf(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('is_self', { user_id: userId });
    if (error) throw error;
    return !!data;
  } catch (err) {
    console.error('Error checking self:', err);
    return false;
  }
}

export async function getUserRole(): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('get_user_role');
    if (error) throw error;
    return data || 'cliente';
  } catch (err) {
    console.error('Error getting user role:', err);
    return 'cliente';
  }
}

export async function getUserName(userId: string): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('get_user_name', { user_id: userId });
    if (error) throw error;
    return data || '';
  } catch (err) {
    console.error('Error getting user name:', err);
    return '';
  }
}

export async function getUserWhatsapp(userId: string): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('get_user_whatsapp', { user_id: userId });
    if (error) throw error;
    return data || '';
  } catch (err) {
    console.error('Error getting user whatsapp:', err);
    return '';
  }
}

export async function isUserBlocked(userId: string): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('is_user_blocked', { user_id: userId });
    if (error) throw error;
    return !!data;
  } catch (err) {
    console.error('Error checking if user is blocked:', err);
    return false;
  }
}

// Re-export everything from the auth module
export * from './auth/index';